<template>
    <div>
        <div v-if="item && nome_campo && item[nome_campo]">
            <div class="form-row" v-for="(campo, icx) in this.item[this.nome_campo]" :key="icx">
                <div class="col col-12" :class="campo.campo == 'campo' ? 'col-md-2' : 'col-md-4'">
                    <az-input
                        type="select"
                        :optionsList="item.campos_disponiveis"
                        optionsData="id"
                        sizing="sm"
                        :label="icx ? '' : 'Campo'"
                        v-model="campo.campo">
                        <template v-slot:button-pre>
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-outline-danger" @click="remover_campo(icx)">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-2" v-if="campo.campo == 'campo'">
                    <az-input
                        sizing="sm"
                        :label="icx ? '' : 'Campo'" 
                        placeholder="Id do Campo..."
                        v-model="campo.hashtag" />
                </div>
                <div class="col col-12 col-md-4">
                    <az-input
                        sizing="sm"
                        :label="icx ? '' : 'Título'" 
                        placeholder="Título..."
                        v-model="campo.titulo" />
                </div>
                <div class="col col-12 col-md-1">
                    <az-input
                        sizing="sm"
                        :label="icx ? '' : 'Linha'" 
                        type="number"
                        v-model="campo.linha" />
                </div>
                <div class="col col-12 col-md-1">
                    <az-input
                        sizing="sm"
                        :label="icx ? '' : 'Ordem'" 
                        type="number"
                        v-model="campo.ordem" />
                </div>
                <div class="col col-12 col-md-2">
                    <az-input
                        sizing="sm"
                        :label="icx ? '' : 'Largura (%)'" 
                        type="number"
                        v-model="campo.largura" />
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-sm btn-primary" @click="incluir_campo()">
            <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
    </div>
</template>

<script>
import AzInput from '../shared/forms/AzInput.vue';

export default {
    components: {
        AzInput
    },

    props: ['nome_campo', 'item'],

    methods: { 
        incluir_campo() { 
            if ( !this.item[this.nome_campo] ) { 
                this.$set(this.item, this.nome_campo, []);
            }
            
            this.item[this.nome_campo].push({ 
                campo: "", 
                titulo: "",
                linha: 1,
                largura: 100, 
            });
        },

        remover_campo(icx) { 
            this.item[this.nome_campo].splice(icx, 1);
        }
    }
}
</script>
